/**
 * clase de utilidad con regex comunes
 */
export default function useRegexConstants() {
  /**
   * Regex usada para campos con Nombres y apellidos, admite letras, admite espacios, y varios valores comunes en nombres, como
   * pueden ser guiones, tildes y acentos internacionales.
   *
   * @type {RegExp} regex
   */
  const REGEX_VALID_NOMBRE =
    /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆŠŽ∂ð ,.'-]+$/u;

  /**
   * Regex usada para validacion de teléfonos.
   * Los valores coinciden non un solo carácter en el rango entre 0 y 9
   * Los valores coinciden con un solo carácter de la lista + -
   *
   * @type {RegExp}
   */
  const REGEX_VALID_TELEFONO = /^[0-9+-]+$/;

  /**
   * Regex usada para validacion de corres electrónicos
   *
   * @type {RegExp}
   */
  const REGEX_VALID_EMAIL =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const REGEX_VALID_DOCUMENTO_ESPANOL = /^[A-Z0-9]{9}$/;
  const REGEX_VALID_DNI = /^[0-9]{8}[A-Z]$/;
  const REGEX_VALID_NIE_ESPECIAL = /^T[0-9]{8}$/;
  const REGEX_VALID_NIE = /^[XYZ][0-9]{7}[A-Z]$/;
  const REGEX_VALID_CIF = /^[ABCDEFGHJNPQRSUVW][0-9]{7}[A-Z0-9]$/;
  const REGEX_VALID_CIF_LETRA = /[A-Z]/;
  const REGEX_VALID_COD_POSTAL = /^(0[1-9]|[1-4][0-9]|5[0-2])\d{3}$/;

  return {
    REGEX_VALID_NOMBRE,
    REGEX_VALID_TELEFONO,
    REGEX_VALID_EMAIL,
    REGEX_VALID_DOCUMENTO_ESPANOL,
    REGEX_VALID_DNI,
    REGEX_VALID_NIE_ESPECIAL,
    REGEX_VALID_NIE,
    REGEX_VALID_CIF,
    REGEX_VALID_CIF_LETRA,
    REGEX_VALID_COD_POSTAL
  };
}
